/**
 * Feature flags — flip to true to show quiz-related UI and flows again.
 */
export const SHOW_QUIZ_FEATURES = false;

/** When false, new and existing users are not sent to /onboarding; they go straight to the app. */
export const REQUIRE_ONBOARDING = false;
